export interface breakClass {
    AccountBreakTypeId: number
    AccountId: number
    BreakType: string
    CreatedByEmployeeId: number
    CreatedOn: Date | undefined
    IsDeleted: boolean
    IsDisabled: boolean
    ModifiedByEmployeeId: number
    ModifiedOn: Date | undefined
    isSelected:number
}



export const breakInitialsForAdd={
    BreakType: "",
    IsDisabled:false
}

export const breakInitialsForUpdate = {
    BreakType: "",
    AccountBreakTypeId:"",
    IsDisabled:false
}